// Wraps the marketing routes. Mounted twice in App.js: once bare (English) and
// once under a ":lang" segment. Keeps i18next's active language and the
// <html lang> attribute in sync with the URL, and bounces unknown locale
// prefixes (e.g. /xx/pricing) back to the English home page.
import { useEffect } from 'react';
import { useParams, Navigate, Outlet } from 'react-router-dom';
import i18n, { SUPPORTED_LNGS, DEFAULT_LNG } from './index';

export default function LocaleLayout() {
  const { lang } = useParams();
  const invalid = lang != null && !SUPPORTED_LNGS.includes(lang);
  const active = lang || DEFAULT_LNG;

  useEffect(() => {
    if (invalid) return;
    if (i18n.language !== active) i18n.changeLanguage(active);
    if (typeof document !== 'undefined') document.documentElement.lang = active;
  }, [active, invalid]);

  if (invalid) return <Navigate to="/" replace />;
  return <Outlet />;
}
